const MonitoramentoActionTypes = {
    MONITORAMENTO: "tipo/monitoramento",
}

export default MonitoramentoActionTypes;